<!--
  Une pastille d'état : icône ET mot, jamais la couleur seule.

  Tout le module signalait ses états par la seule couleur — pastilles, chips,
  bordures de tuile. Invisible pour qui ne distingue pas le rouge de l'orange,
  et illisible en impression noir et blanc. Le composant rend structurellement
  impossible d'afficher une couleur sans son libellé.
-->
<template>
  <span class="hv2-pill" :class="tone ? `is-${tone}` : ''" :title="title || label">
    <feather-icon v-if="icon" :icon="icon" svgClasses="h-3 w-3" />
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'HvPill',
  props: {
    label: { type: String, required: true },
    tone: { type: String, default: '' },   // ok | warn | danger | info | ''
    icon: { type: String, default: '' },
    title: { type: String, default: '' }
  }
}
</script>
